import { render, staticRenderFns } from "./MyWatchlists.vue?vue&type=template&id=54e46b38&scoped=true&"
import script from "./MyWatchlists.vue?vue&type=script&lang=js&"
export * from "./MyWatchlists.vue?vue&type=script&lang=js&"
import style0 from "./MyWatchlists.vue?vue&type=style&index=0&id=54e46b38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e46b38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VIcon,VListItem,VListItemTitle})
